import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {BaseView} from "../../../../core/view/base.view";
import {SaleSummaryModel} from "../../entity/saleSummary.model";
import {SALE_DIRECTION} from "../../entity/sale.model";

@Component({
    selector: 'app-sale-summary-field',
    templateUrl: './sale-summary-field.component.html',
})
export class SaleSummaryFieldComponent extends BaseView implements OnChanges {

    @Input() entity: SaleSummaryModel;

    title: string;

    constructor() {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['entity']) {
            if (this.entity) {
                if (this.entity?.label) {
                    this.title = this.entity.label;
                } else {
                    this.title = this.entity.direction.value === SALE_DIRECTION.SALE_DIRECTION_IN ? 'Achat' : 'Vente'
                }
            }
        }
    }




    redirect() {
        this.redirectTo('mawi-erp-app/ventes/' + this.entity?.id + '/voir');
    }

}
